<template lang="pug">
    div(v-if="activeRefinementCount > 0" class="flex flex-wrap")
        template(v-for="refinement in displayRefinements")
            div(
                @click="clearRefinement(refinement.attributeText, refinement.attribute, refinement.value)"
                class="flex items-center overflow-hidden text-sm mb-1 mr-2 cursor-pointer"
            )
                div(class="py-1 px-2 flex items-center bg-white border border-solid border-gray-light rounded")
                    template
                        span(class="capitalize") {{ screamingSnakeToTitle(refinement.display) }}
                    CloseIcon(class="ml-2 w-2 h-2 fill-current text-gray")

        div(
            v-if="activeRefinementCount > displayLimit"
            @click="showAllRefinements = !showAllRefinements"
            class="flex items-center overflow-hidden border border-solid border-gray-light rounded text-sm mb-1 mr-2 cursor-pointer"
        )
            div(class="py-1 px-2 flex items-center bg-white")
                template(v-if="showAllRefinements") Show Less
                template(v-else) + {{ activeRefinementCount - displayLimit }}

        div(
            @click="clearRefinements"
            class="flex items-center overflow-hidden border border-solid border-gray-light rounded text-sm mb-1 mr-2 cursor-pointer"
        )
            div(class="py-1 px-2 flex items-center bg-white") Clear All

</template>

<script>
import SearchComponent from '@/components/search/component'
import CloseIcon from '@/assets/common/x?inline'

export default {
    components: {
        CloseIcon,
    },
    extends: SearchComponent,
    data() {
        return {
            displayLimit: 8,
            showAllRefinements: false,
        }
    },
    computed: {
        activeRefinementCount() {
            return this.$searchContext.state.activeRefinementCount
        },
        activeRefinements() {
            return this.$searchContext.state.activeRefinements
        },
        displayRefinements() {
            return Object.entries(this.activeRefinements)
                .reduce((acc, [attribute, values]) => {
                    // Format the values of the attribute
                    const formattedAttributeValues = this.formatAttributeValues(attribute, values)

                    acc.push(...formattedAttributeValues)

                    return acc
                }, [])
                .slice(0, this.showAllRefinements ? undefined : this.displayLimit)
        },
    },
    methods: {
        screamingSnakeToTitle(value) {
            return value.toLowerCase().replace('_', ' ')
        },
        formatAttributeValues(attribute, values) {
            return values.map(({ value, display }) => ({
                attributeText: attribute,
                attribute,
                display,
                value,
            }))
        },
        clearRefinement(title, attribute, refinement) {
            this.$uiEvents.$emit('facetClicked', {
                facet: title.toLowerCase(),
                value: refinement.toLowerCase(),
                route: this.$route,
            })

            this.$searchContext.removeRefinements(attribute, refinement)

            const routeObj = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(routeObj)
        },
        clearRefinements() {
            this.$searchContext.clearRefinements()

            const route = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(route)
        },
    },
}
</script>
